import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAllSpacePrevent]'
})
export class AllSpacePreventDirective {

  @Input() isFistUpper = false;
  @Input() isVariableName = false;



  constructor(private el: ElementRef, private control:NgControl) { 
  }
  @HostListener('input', ['$event'])
  onInput() {
    let myString = this.el.nativeElement.value
    myString = myString.replace(/\s/g, '');
    if(myString.length && this.isFistUpper){
      myString = myString[0].toUpperCase() + myString.slice(1);
    }
    if(myString.length && this.isVariableName) {
      if (!/^\$/.test(myString[0])) {
        myString = `$${myString}`;
      }
    }
    this.el.nativeElement.value = myString
    if(this.control){
      this.control.control?.patchValue(myString);
    }
  }
}
